export interface ProfileAddress {
  id: string
  label: string
  street: string
  city: string
  postalCode: string
  primary: boolean
}

export interface NotificationChannel {
  id: string
  label: string
  description: string
  enabled: boolean
}

export interface NotificationTopic {
  id: string
  label: string
  description: string
  enabled: boolean
  essential: boolean
}

export interface Consent {
  id: string
  title: string
  purpose: string
  grantedOn: string
  status: 'accorde' | 'a-confirmer'
  withdrawable: boolean
}

export interface Invoice {
  id: string
  date: string
  service: string
  reference: string
  amount: string
  status: 'payee' | 'a-payer'
}

export interface PolicyDoc {
  id: string
  title: string
  description: string
}

export const profile = {
  firstName: 'Bryon',
  lastName: 'Mickelson',
  initials: 'BM',
  birthDate: '1970-02-04',
  phone: '(780) 826-0210',
  phoneSecondary: '',
  mobile: '(780) 555-0184',
  email: 'bryon.mickelson@example.com',
}

export const addresses: ProfileAddress[] = [
  {
    id: 'principale',
    label: 'Home',
    street: '5108 - 46 Street',
    city: 'Bonnyville, Alberta',
    postalCode: 'T9N 2J7',
    primary: true,
  },
  {
    id: 'secondaire',
    label: 'Second property',
    street: '4703 - 51 Avenue',
    city: 'Bonnyville, Alberta',
    postalCode: 'T9N 1M4',
    primary: false,
  },
]

export const notificationChannels: NotificationChannel[] = [
  { id: 'courriel', label: 'Email', description: 'bryon.mickelson@example.com', enabled: true },
  { id: 'sms', label: 'Text message', description: '(780) 555-0184', enabled: true },
  { id: 'push', label: 'Mobile notifications', description: 'bciti+ app', enabled: false },
]

export const notificationTopics: NotificationTopic[] = [
  {
    id: 'alertes',
    label: 'Important alerts',
    description: 'Boil water advisories, emergencies, public safety.',
    enabled: true,
    essential: true,
  },
  {
    id: 'avis',
    label: 'Town notices',
    description: 'Council meetings, consultations, public notices.',
    enabled: true,
    essential: false,
  },
  {
    id: 'services',
    label: 'Services and operations',
    description: 'Collections, roadwork, traffic detours.',
    enabled: true,
    essential: false,
  },
  {
    id: 'loisirs',
    label: 'Recreation and culture',
    description: 'Programs, registration, events.',
    enabled: false,
    essential: false,
  },
  {
    id: 'rappels',
    label: 'Personal reminders',
    description: 'Tax due dates, renewals, bookings.',
    enabled: true,
    essential: false,
  },
]

export const consents: Consent[] = [
  {
    id: 'communications',
    title: 'Electronic communications',
    purpose: 'Receive Town notices and communications by email and text message.',
    grantedOn: 'Granted March 12, 2026',
    status: 'accorde',
    withdrawable: true,
  },
  {
    id: 'personnalisation',
    title: 'Use of my data to personalize my services',
    purpose: 'Show the collections, reminders and services that match your address.',
    grantedOn: 'Granted March 12, 2026',
    status: 'accorde',
    withdrawable: true,
  },
  {
    id: 'partage',
    title: 'Data sharing with a connected Town service',
    purpose: 'Share your file with the Bonnyville Municipal Library to activate your citizen card.',
    grantedOn: 'Requested August 21, 2026',
    status: 'a-confirmer',
    withdrawable: false,
  },
]

export const invoices: Invoice[] = [
  {
    id: 'f-1042',
    date: 'August 14, 2026',
    service: 'Summer day camp — 2026',
    reference: 'INV-1042',
    amount: '$285.00',
    status: 'a-payer',
  },
  {
    id: 'f-0987',
    date: 'July 2, 2026',
    service: 'Development permit',
    reference: 'INV-0987',
    amount: '$120.00',
    status: 'payee',
  },
  {
    id: 'f-0912',
    date: 'March 3, 2026',
    service: 'Property taxes — first instalment',
    reference: 'INV-0912',
    amount: '$842.50',
    status: 'payee',
  },
]

export const policyDocs: PolicyDoc[] = [
  {
    id: 'vie-privee',
    title: 'Privacy centre',
    description: 'How your personal information is protected and used.',
  },
  {
    id: 'conditions',
    title: 'Terms of use',
    description: 'The rules that apply to the Town’s digital services.',
  },
  {
    id: 'charte-ia',
    title: 'AI ethics charter',
    description:
      'Our commitments to a responsible, supervised and transparent use of artificial intelligence.',
  },
]

export const atnaQuestions = [
  'How is my data used?',
  'How do I change my consents?',
  'How do I delete my account?',
]
